import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { RefreshTokenResponse, User } from '../interfaces/user/user.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly TOKEN_KEY = 'auth_token';
  private readonly USER_KEY = 'user';
  private readonly SELECTED_ADDRESS_KEY ='selected_address';
  private currentUserSubject = new BehaviorSubject<User | null>(null);

  constructor(
    private storageService: StorageService,
    private http: HttpClient,
  ) {
    this.loadUserFromStorage();
  }

  private loadUserFromStorage(): void {
    const user = this.storageService.getItem<User>(this.USER_KEY);
    this.currentUserSubject.next(user);
  }
  private readonly apiUrl = environment.apiUrl;

  setToken(token: string): void {
    this.storageService.setItem(this.TOKEN_KEY, token);
  }

  getToken(): string | null {
    return this.storageService.getItem(this.TOKEN_KEY);
  }

  refreshToken():Observable<RefreshTokenResponse>{
    let token=this.getToken();
    let headers=new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
    return this.http.post<RefreshTokenResponse>(`${this.apiUrl}/auth/refresh`,{},{headers})
  }
  setUser(user: User): void {
    this.storageService.setItem(this.USER_KEY, user);
    this.currentUserSubject.next(user);
  }

  getUser(): User | null {
    return this.storageService.getItem(this.USER_KEY);
  }

  getCurrentUser(): Observable<User | null> {
    return this.currentUserSubject.asObservable();
  }

  clearAuth(): void {
    this.storageService.removeItem(this.TOKEN_KEY);
    this.storageService.removeItem(this.USER_KEY);
    this.currentUserSubject.next(null);
    this.storageService.removeItem(this.SELECTED_ADDRESS_KEY);
  }

  isLoggedIn(): boolean {
    return this.storageService.hasItem(this.TOKEN_KEY);
  }


  autoCloseSession(): void {
    this.clearAuth();
  }
}
